export default __webpack_public_path__ + "static/media/1.084284d9.jpg";